import React from 'react';

import './HomeNewsTopTenTab.css';

//props => calcDate, TopTenData;
const HomeNewsTopTenTab = (props) => {
  const newsTabContents = props.newsTabContents;

  const PubDate = ({pubdate})=> {
    let year = pubdate.substr(0,4);
    let month = pubdate.substr(4,2);
    let day = pubdate.substr(6,2);
    return <>{year+"-"+month+"-"+day}</>
  }

  return (
    <>
			<div className="parbase badgea spanMargin">              
        <div className="span4">
          <div className="mainTitle nielsen-orange">NEWS MEDIA KEYWORD<br />TOP 10<div>
              <table className="tablestyMain newsMedia">
                <tr>
                  <th width="20%">순위</th>
                  <th width="50%">키워드</th>
                  <th width="30%">증감률(%)</th>
                </tr>
                {newsTabContents.map((contentItem,contentIndex) => {
                  return(
                    <tr>
                      <td width="20%">
                        {contentIndex+1}
                      </td>
                      <td width="50%">
                        {contentItem.keyword}
                      </td>
                      <td width="30%">
                          {contentItem.ratio == "NEW" ?
                            <span className="news-tab-new">{contentItem.ratio}</span>
                            : contentItem.ratio}
                      </td>
                    </tr>
                  )
                })}
              </table>
              <div className="UpdateDate"><PubDate pubdate={props.newsPubDate} /></div>
              </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default HomeNewsTopTenTab;